import { LitElement, html, svg } from 'lit';

export class IconPhone24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Smarttelefon</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.751.75h-9.5a3 3 0 0 0-3 3v16.5a3 3 0 0 0 3 3h9.5a3 3 0 0 0 3-3V3.75a3 3 0 0 0-3-3ZM4.5 18h15"></path></svg>`; }
}
if (!customElements.get('f-icon-phone24', IconPhone24)) {
  customElements.define('f-icon-phone24', IconPhone24);
}